import { postRequest } from '@/libs/axios'

// 分组分页查询
export const pagePostalCodeGroup = (params) => {
  return postRequest('/ndt/postalCodeGroup/page', params)
}

// 新增分组
export const createPostalCodeGroup = (params) => {
  return postRequest('/ndt/postalCodeGroup/create', params)
}

// 更新分组
export const updatePostalCodeGroup = (params) => {
  return postRequest('/ndt/postalCodeGroup/update', params)
}

export const postalCodeGroupList = () => {
  return postRequest('/ndt/postalCodeGroup/list')
}